class modelClass {
  GetData(data) {
    this.draft = data.draft

    //GeneralInfo
    this.id = data.id
    this.name = data.name
    this.catalogType = data.catalogType
    this.shoeType = data.shoeType
    this.imagetoremove = data.imagetoremove
    this.imagepresent = data.imagepresent
    this.image = data.image
    this.rendertoremove = data.rendertoremove
    this.renderpresent = data.renderpresent
    this.render = data.render
    //Tomaio
    this.pell1mat = data.pell1mat
    this.pell1var = data.pell1var
    this.pell2mat = data.pell2mat
    this.pell2var = data.pell2var
    this.pell3mat = data.pell3mat
    this.pell3var = data.pell3var
    this.seasontags = data.seasontags
    this.addingchar = data.addingchar

    //Fodera
    this.addingcharfod = data.addingcharfod

    //Suola

    //allacciatura
    this.allacci = data.allacci
    this.var_ling_dx = data.var_ling_dx
    this.var_ling_sx = data.var_ling_sx

    //rifinitura
    this.riftype = data.riftype
    this.mountag = data.mountag
    this.guardmat = data.guardmat
    this.guardvar = data.guardvar
    this.fascmat = data.fascmat
    this.fascvar = data.fascvar

    //allestimento
    this.typecontr = data.typecontr
    this.contrmat = data.contrmat
    this.contrvar = data.contrvar
    this.typesott = data.typesott
    this.sottmat = data.sottmat
    this.sottvar = data.sottvar
    this.typepun = data.typepun
    this.punmat = data.punmat
    this.punvar = data.punvar
  }
  returnObject() {
    return {
      draft: this.draft,
      //GeneralInfo
      id: this.id,
      name: this.name,
      catalogType: this.catalogType,
      shoeType: this.shoeType,
      imagetoremove: this.imagetoremove,
      imagepresent: this.imagepresent,
      image: this.image,
      rendertoremove: this.rendertoremove,
      renderpresent: this.renderpresent,
      render: this.render,
      //Tomaio
      pell1mat: this.pell1mat,
      pell1var: this.pell1var,
      pell2mat: this.pell2mat,
      pell2var: this.pell2var,
      pell3mat: this.pell3mat,
      pell3var: this.pell3var,
      seasontags: this.seasontags,
      addingchar: this.addingchar,
      components_to_drill: this.components_to_drill,

      //Fodera
      addingcharfod: this.addingcharfod,
      //suola
      //allacciatura
      allacci: this.allacci,
      var_ling_dx: this.var_ling_dx,
      var_ling_sx: this.var_ling_sx,

      //rifinitura
      riftype: this.riftype,
      mountag: this.mountag,
      guardmat: this.guardmat,
      guardvar: this.guardvar,
      fascmat: this.fascmat,
      fascvar: this.fascvar,

      //allestimento
      typecontr: this.typecontr,
      contrmat: this.contrmat,
      contrvar: this.contrvar,
      typesott: this.typesott,
      sottmat: this.sottmat,
      sottvar: this.sottvar,
      typepun: this.typepun,
      punmat: this.punmat,
      punvar: this.punvar,
    }
  }
  constructor() {
    this.draft = true
    //GeneralInfo
    this.id = null
    this.name = null
    this.catalogType = null
    this.shoeType = null
    this.imagetoremove = false
    this.imagepresent = false
    this.image = null
    this.rendertoremove = false
    this.renderpresent = false
    this.render = null
    //Tomaio
    this.pell1mat = null
    this.pell1var = null
    this.pell2mat = null
    this.pell2var = null
    this.pell3mat = null
    this.pell3var = null
    this.seasontags = null
    this.addingchar = []
    this.components_to_drill = []

    //Fodera
    this.addingcharfod = []
    //suola
    //allacciatura
    this.allacci = []
    this.var_ling_dx = []
    this.var_ling_sx = []

    //rifinitura
    this.riftype = null
    this.mountag = null
    this.guardmat = null
    this.guardvar = null
    this.fascmat = null
    this.fascvar = null

    //allestimento
    this.typecontr = null
    this.contrmat = null
    this.contrvar = null
    this.typesott = null
    this.sottmat = null
    this.sottvar = null
    this.typepun = null
    this.punmat = null
    this.punvar = null
  }
}

export class modelTailored extends modelClass {
  GetData(data) {
    super.GetData(data)
    //GeneralInfo
    //Tomaio
    this.pell4mat = data.pell4mat !== undefined ? data.pell4mat : null
    this.pell4var = data.pell4var !== undefined ? data.pell4var : null
    this.pell5mat = data.pell5mat !== undefined ? data.pell5mat : null
    this.pell5var = data.pell5var !== undefined ? data.pell5var : null
    //Fodera
    this.fodantmat = data.fodantmat
    this.fodantvar = data.fodantvar
    this.fodposmat = data.fodposmat
    this.fodposvar = data.fodposvar
    //Suola\
    this.battmat = data.battmat
    this.battvar = data.battvar
    this.tacczepp = data.tacczepp
    this.tacczeppvar = data.tacczeppvar
    this.intemat = data.intemat
    this.intevar = data.intevar
    this.tacc = data.tacc
    this.taccvar = data.taccvar
    this.punt_risv = data.punt_risv
    //allacciatura
    //rifinitura\
    //allestimento
  }
  returnObject() {
    return {
      ...super.returnObject(),
      //GeneralInfo
      //Tomaio
      pell4mat: this.pell4mat,
      pell4var: this.pell4var,
      pell5mat: this.pell5mat,
      pell5var: this.pell5var,
      //Fodera
      fodantmat: this.fodantmat,
      fodantvar: this.fodantvar,
      fodposmat: this.fodposmat,
      fodposvar: this.fodposvar,
      //suola
      sole: this.sole,
      battmat: this.battmat,
      battvar: this.battvar,
      tacczepp: this.tacczepp,
      tacczeppvar: this.tacczeppvar,
      intemat: this.intemat,
      intevar: this.intevar,
      tacc: this.tacc,
      taccvar: this.taccvar,
      punt_risv: this.punt_risv,
      //allacciatura
      //rifinitura
      //allestimento
    }
  }
  constructor() {
    super()
    //GeneralInfo
    //Tomaio
    this.pell4mat = null
    this.pell4var = null
    this.pell5mat = null
    this.pell5var = null
    //Fodera
    this.fodantmat = null
    this.fodantvar = null
    this.fodposmat = null
    this.fodposvar = null
    //suola
    this.sole = null
    this.battmat = null
    this.battvar = null
    this.tacczepp = null
    this.tacczeppvar = null
    this.intemat = null
    this.intevar = null
    this.tacc = null
    this.taccvar = null
    this.punt_risv = false
    //allacciatura
    //rifinitura
    //allestimento
  }
}

export class modelFits extends modelClass {
  GetData(data) {
    super.GetData(data)
    //GeneralInfo
    //Tomaio
    this.pell4mat = data.pell4mat
    this.pell4var = data.pell4var
    //Fodera
    //Suola
    this.sole = data.sole
    this.soles = data.soles
    this.sole_default = data.sole_default
    this.shape_left = data.shape_left
    this.shape_right = data.shape_right
    //allacciatura
    this.allacci_default = data.allacci_default
    //rifinitura\
    //allestimento
  }
  returnObject() {
    return {
      ...super.returnObject(),
      //GeneralInfo
      //Tomaio
      pell4mat: this.pell4mat,
      pell4var: this.pell4var,
      //Fodera
      //suola
      sole: this.sole,
      soles: this.soles,
      sole_default: this.sole_default,
      shape_left: this.shape_left,
      shape_right: this.shape_right,
      //allacciatura
      allacci_default: this.allacci_default,
      //rifinitura
      //allestimento
    }
  }
  constructor() {
    super()
    //GeneralInfo
    //Tomaio
    this.pell4mat = null
    this.pell4var = null
    //Fodera
    //suola
    this.sole = {}
    this.soles = []
    this.sole_default = null
    this.shape_left = null
    this.shape_right = null
    //allacciatura
    this.allacci_default = null
  }
}

export class modelModular extends modelClass {
  GetData(data) {
    super.GetData(data)
    //GeneralInfo
    this.hasSecondaryPrev = data.hasSecondaryPrev
    //Tomaio
    this.possiblePel = data.possiblePel
    this.possibleRip = data.possibleRip
    this.puncture = data.puncture
    //fodera
    this.hasDrilledFodera = data.hasDrilledFodera
    // allacciatura
    this.hasVelcro = data.hasVelcro
    this.velcri_length = data.velcri_length
    this.hasForteAlto = data.hasForteAlto
    //Suola
    this.sole = data.sole
    this.soles = data.soles
    this.sole_default = data.sole_default
    this.shape_left = data.shape_left
    this.shape_right = data.shape_right
    this.sizes = data.sizes
  }
  returnObject() {
    return {
      ...super.returnObject(),
      //GeneralInfo
      hasSecondaryPrev: this.hasSecondaryPrev,
      //Tomaio
      possiblePel: this.possiblePel,
      possibleRip: this.possibleRip,
      puncture: this.puncture,
      //fodera
      hasDrilledFodera: this.hasDrilledFodera,
      //allacciatura
      hasVelcro: this.hasVelcro,
      velcri_length: this.velcri_length,
      hasForteAlto: this.hasForteAlto,
      //suola
      sole: this.sole,
      soles: this.soles,
      sole_default: this.sole_default,
      shape_left: this.shape_left,
      shape_right: this.shape_right,
      sizes: this.sizes,
    }
  }
  constructor() {
    super()
    //GeneralInfo
    this.hasSecondaryPrev = false
    //Tomaio
    this.possiblePel = []
    this.possibleRip = []
    this.puncture = false
    //fodera
    this.hasDrilledFodera = false
    //allacciatura
    this.hasVelcro = false
    this.velcri_length = null
    this.hasForteAlto = false
    //suola
    this.sole = {}
    this.soles = []
    this.sole_default = null
    this.shape_left = null
    this.shape_right = null
    this.sizes = {}
  }
}

export class modelInsole {
  GetData(data) {
    this.draft = data.draft

    //GeneralInfo
    this.id = data.id
    this.name = data.name
    this.imagetoremove = data.imagetoremove
    this.imagepresent = data.imagepresent
    this.image = data.image
    this.rendertoremove = data.rendertoremove
    this.renderpresent = data.renderpresent
    this.render = data.render

    this.addingchar = data.addingchar

    //Materials
    this.insoleBaseMat = data.insoleBaseMat
    this.insoleBaseVar = data.insoleBaseVar
    this.insoleCoverMat = data.insoleCoverMat
    this.insoleCoverVar = data.insoleCoverVar
    this.insoleFillMat = data.insoleFillMat
    this.insoleFillVar = data.insoleFillVar
    this.forefootInsertMat = data.forefootInsertMat
    this.forefootInsertVar = data.forefootInsertVar
    this.midfootInsertMat = data.midfootInsertMat
    this.midfootInsertVar = data.midfootInsertVar
    this.backfootInsertMat = data.backfootInsertMat
    this.backfootInsertVar = data.backfootInsertVar
    //Dime
    this.dime = data.dime
    this.dime_description = data.dime_description
    this.dime_fondo = data.dime_fondo != null ? data.dime_fondo : null
    this.cambratura_fondo = data.cambratura_fondo != null ? data.cambratura_fondo : null
  }
  returnObject() {
    return {
      draft: this.draft,
      //GeneralInfo
      id: this.id,
      name: this.name,
      imagetoremove: this.imagetoremove,
      imagepresent: this.imagepresent,
      image: this.image,
      rendertoremove: this.rendertoremove,
      renderpresent: this.renderpresent,
      render: this.render,
      addingchar: this.addingchar,
      insoleBaseMat: this.insoleBaseMat,
      insoleBaseVar: this.insoleBaseVar,
      insoleCoverMat: this.insoleCoverMat,
      insoleCoverVar: this.insoleCoverVar,
      insoleFillMat: this.insoleFillMat,
      insoleFillVar: this.insoleFillVar,
      forefootInsertMat: this.forefootInsertMat,
      forefootInsertVar: this.forefootInsertVar,
      midfootInsertMat: this.midfootInsertMat,
      midfootInsertVar: this.midfootInsertVar,
      backfootInsertMat: this.backfootInsertMat,
      backfootInsertVar: this.backfootInsertVar,
      dime: this.dime,
      dime_description: this.dime_description,
      dime_fondo: this.dime_fondo != null ? this.dime_fondo : null,
      cambratura_fondo: this.cambratura_fondo != null ? this.cambratura_fondo : null,
    }
  }
  constructor() {
    this.draft = true
    //GeneralInfo
    this.id = null
    this.name = null
    this.imagetoremove = false
    this.imagepresent = false
    this.image = null
    this.rendertoremove = false
    this.renderpresent = false
    this.render = null
    this.addingchar = []
    this.insoleBaseMat = null
    this.insoleBaseVar = null
    this.insoleCoverMat = null
    this.insoleCoverVar = null
    this.insoleFillMat = null
    this.insoleFillVar = null
    this.forefootInsertMat = null
    this.forefootInsertVar = null
    this.midfootInsertMat = null
    this.midfootInsertVar = null
    this.backfootInsertMat = null
    this.backfootInsertVar = null
    this.dime = null
    this.dime_description = null
    this.dime_fondo = null
    this.cambratura_fondo = null
  }
}

export function compareModelPosition(a, b) {
  const pa = Number.isInteger(a.position) ? a.position : Infinity
  const pb = Number.isInteger(b.position) ? b.position : Infinity
  if (pa !== pb) return pa - pb
  return (a.name || '').localeCompare(b.name || '')
}
